import styles from "../Win.module.css"

export const Button = ({ type, onClick }) => {
	return <div className={`${styles.winButton} ${styles[type]}`} onClick={onClick}></div>
}
